import script from "./ApplicationStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationStep.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationStep.vue?vue&type=style&index=0&id=dea2d412&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dea2d412"]])

export default __exports__